import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1876bb4e"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=1876bb4e&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9fb47bbfd3250863a168a7beb9ae16ff/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports